import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import * as _ from 'underscore';

import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';

HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);
@Component({
	selector: 'app-solidgauge-donut',
	styleUrls: ['./solidgauge-donut.component.css'],
	templateUrl: './solidgauge-donut.component.html'
})
export class SolidgaugeDonutComponent implements OnInit, OnChanges {
	@ViewChild('chartElement', { static: true }) chartElement: ElementRef;
	@Input() chartData: any;
	@Input() donutOptions: any;

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['chartData']) {
			if (this.chartData) {
				if (this.chartData.length > 0) {
					if (this.chartData[0].data) {
						const isNotEmpty = (item) => item.y > 0;
						if (!this.chartData[0].data.every(isNotEmpty)) {
							this.chartData[0].data = [];
						}
						this.drawChart();
					}
				}
			}
		}
	}

	ngOnInit(): void {
		this.drawChart();
	}

	drawChart(): void {
		Highcharts.chart({
			chart: {
				height: this.donutOptions && this.donutOptions.width ? this.donutOptions.width : 230,
				renderTo: this.chartElement.nativeElement,
				type: 'solidgauge',
				width: this.donutOptions && this.donutOptions.height ? this.donutOptions.height : 230
			},
			credits: {
				enabled: false
			},
			pane: {
				background: [
					{
						backgroundColor: '#f0f0f0',
						borderColor: 'none',
						borderWidth: 0,
						innerRadius: '60%',
						outerRadius: '100%'
					}
				],
				endAngle: 360,
				startAngle: 0
			},
			plotOptions: {
				gauge: {
					dataLabels: {
						borderWidth: 0,
						enabled: false,
						useHTML: true
					},
					pivot: {
						radius: 0
					},
					stickyTracking: false
				},
				solidgauge: {
					dataLabels: {
						borderWidth: 0,
						enabled: false,
						useHTML: true
					},
					rounded: true,
					stickyTracking: false
				}
			},
			series: this.chartData,
			title: {
				text: null
			},
			tooltip: {
				backgroundColor: 'none',
				borderWidth: 0,
				enabled: false,
				pointFormat:
					'{series.name}<br><span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}%</span>',
				// tslint:disable-next-line: object-literal-shorthand
				positioner: function (labelWidth: any): any {
					return {
						x: (this.chart.chartWidth - labelWidth) / 2,
						y: this.chart.plotHeight / 2 + 15
					};
				},
				shadow: false,
				style: {
					fontSize: '16px'
				}
			},
			yAxis: {
				lineWidth: 0,
				max: 100,
				min: 0,
				tickPositions: [],
				visible: false
			}
		});
	}
}
